import { exists, getDistance } from '@/helpers/utilities';

export let mixin = ({ node = null, config = {} } = {}) => {
    if (!node) return false;

    let state = {
        node,
        config,
        grid: document.querySelector(`[data-js="grid-fill"]`),
        customEvent: 'ctacGridLayoutComplete',
    };

    let module = {
        makeLayout() {
            setTimeout(() => {
                state.node.parentNode.classList.add('js-is-snapped');
            }, 150);
        },
        setEventBindings() {
            window.addEventListener(state.customEvent, this.makeLayout.bind(this));
        },
        init() {
            if (!exists(state.node)) return;
            this.setEventBindings();
        },
    };

    return module.init();
};

export default {
    init({ selector, config = {} }) {
        let selected = document.querySelectorAll(selector);
        if (!selected.length) return;

        return [...selected].map((node, index) => {
            return mixin({ node, config });
        });
    },
};
